import { createSlice } from '@reduxjs/toolkit';

// Temporary shim reducer to keep legacy selectors from crashing
// This should be removed once all components use SecureAuthContext.
const initialState = {
  token: null,
  user: null,
  status: 'idle',
  error: null,
};

const dummyAuthSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    // no-op reducers to avoid breaking imports
    resetAuthState: () => initialState,
  },
});

export const { resetAuthState } = dummyAuthSlice.actions;
export default dummyAuthSlice.reducer;









